/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.8.14",
    versionName: "0.2.0-nightly.2025.8.14",
    versionChannel: "nightly",
    buildDate: "2025-08-14T00:08:14.007Z",
    commitHash: "1192cc62baa9f1acc60d8875f9fd2524f08a4b69",
};
